export default __webpack_public_path__ + "static/media/qr-templated-diesel.93a1ba1f.png";